<template>
    <div class='footer-box'>
        <ul>
            <li>
                <div>Copyright © 2023 COTTON GAME. 保留所有权利</div>
            </li>
            
            <li>
                <div>健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当</div>
            </li>
            <li>
                <div>   适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</div>
            </li>
        </ul>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CottonFooter'
});
</script>

<style scoped lang='css'>
.footer-box {
    box-sizing: border-box;
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: #000000;
}

.footer-box ul {
    width: 100%;
    text-align: center;
}

.footer-box ul li {
    list-style: none;
    margin-top: 1rem;
    margin-bottom: 1rem;
}
</style>